import React from "react";
import { Button } from "../components/Button";
import { getAsset } from "../utilities/assets.utils";

export const CreateBoardCTA = () => {
	return (
		<>
			<div className="text-center flex justify-center items-center mb-5">
				<span className="mr-2 font-semibold">
					Follow 3 simple steps below to get started!
				</span>
				<img src={getAsset("caret.png")} alt="" className="w-2" />
			</div>
			<div className="bg-plugin-1-light flex flex-col items-center rounded-sm p-8 mb-6">
				<img
					src={getAsset("create-board.png")}
					alt=""
					className="w-16 mb-2"
				/>
				<div className="text-xl font-semibold mt-2">
					Create a HootBoard for your organization
				</div>
				<div className="mt-3 mb-6 text-center">
					Register and create your HootBoard at
					hootboard.com/create-board
				</div>
				<Button
					href="https://hootboard.com/create-board?utm_source=hootboard_embed_plugin&utm_medium=web&utm_campaign=backlink_engagements&utm_content=create_board_page&utm_term=backlink_engagement"
					label="Create Now!"
					color="plugin-1"
				/>
			</div>
		</>
	);
};
